type SupportedLang = 'fr' | 'en';

type LocalizedText<T> = Record<SupportedLang, T>;

const NotificationText: LocalizedText<{
  text_copied: string;
  text_copied_failed: string;
  referral_copy: string;
  error: string;
}> = {
  fr: {
    text_copied: 'Texte copié!',
    text_copied_failed: 'Échec de la copie du texte !',
    referral_copy: 'Lien de référencement copier !',
    error: "Une erreur s'est produite, veuillez le signaler à notre support.",
  },
  en: {
    text_copied: 'Text copied!',
    text_copied_failed: 'Failed to copy text!',
    referral_copy: 'Referral link copied!',
    error: 'An error has occurred, please report it to our support.',
  },
};

const showNotification = (text: string, duration = 3000): void => {
  const notification = document.createElement('div');
  notification.classList.add('timed-notification');
  notification.textContent = text;
  document.body.appendChild(notification);
  setTimeout(() => {
    notification.remove();
  }, duration);
};

const attachLegacyMembershipGlobals = (): void => {
  (window as any).NotificationText = NotificationText;
  (globalThis as any).NotificationText = NotificationText;
  (window as any).showNotification = showNotification;
  (globalThis as any).showNotification = showNotification;
};

export { NotificationText, showNotification, attachLegacyMembershipGlobals };
